import React from 'react';
import { useParams } from 'react-router-dom';
import UsageDetailView, { Field, UsageDetailPage, UsageEntriesQuery } from '../converter/UsageDetailView';
import { adminApiService } from '../../services/adminApi';
import { AdminApiUsageRequest } from '../../types/admin';
import { formatDateTimeUTC, formatDuration } from '../../utils/dateTime';
import { apiKeyName, maskApiKey } from '../../utils/apiKey';
import { Badge, instanceLabel } from './shared';

async function loadRequest(id: string, query: UsageEntriesQuery): Promise<UsageDetailPage<AdminApiUsageRequest>> {
  const res = await adminApiService.getApiRequest(id, query);
  return { subject: res.request, entries: res.items, total: res.total };
}

function AdminApiRequestDetail() {
  const { id } = useParams<{ id: string }>();

  return (
    <UsageDetailView<AdminApiUsageRequest>
      id={id}
      backTo="/admin/usage?tab=api"
      pageSizeKey="admin-api-request-files"
      load={loadRequest}
      showOutputTokens
      noun="request"
      title={(request) => apiKeyName(request)}
      titleAside={(request) => <Badge value={request.status} />}
      notice={(request) => request.error_message}
      // An error request has no entries.
      showUsage={(request) => request.status === 'success'}
      fields={(request) => (
        <>
          <Field label="Instance">{instanceLabel(request.instance_name, request.instance_key)}</Field>
          <Field label="Operation">{request.operation}</Field>
          <Field label="API Key">
            {request.api_key_name}
            <span className="text-secondary font-mono ml-2">{maskApiKey(request)}</span>
          </Field>
          <Field label="Started At">{formatDateTimeUTC(request.started_at)}</Field>
          <Field label="Completed At">{formatDateTimeUTC(request.completed_at)}</Field>
          <Field label="Duration">{formatDuration(request.started_at, request.completed_at)}</Field>
        </>
      )}
    />
  );
}

export default AdminApiRequestDetail;
